import { render } from "./ActivateRestaurant.vue?vue&type=template&id=c97c1b20&scoped=true"
import script from "./ActivateRestaurant.vue?vue&type=script&lang=js"
export * from "./ActivateRestaurant.vue?vue&type=script&lang=js"

import "./ActivateRestaurant.vue?vue&type=style&index=0&id=c97c1b20&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c97c1b20"]])

export default __exports__